import React from "react";
import RegistrationsListView from "../Registrations/RegistrationsListView";
import "../../../css/View/VariantRegistrations.css";

const VariantRegistrations = ({ registrations, variantGuid, activeSectionRef  }) => {
  const filteredRegistrations = registrations.filter(
    (r) => r.variantGuid === variantGuid
  );

  return (
    <div className="trip-variant-section trip-variant-registrations">
      <RegistrationsListView registrations={filteredRegistrations}  activeRef={activeSectionRef}/>
    </div>
  );
};

export default VariantRegistrations;